export default __webpack_public_path__ + "static/logo-white-061545d9c71ab17f1c71a6dbd5af9600.svg";